import { createAction } from 'actions/utils'

export const SET_PIN = 'SET_PIN'
export const setPinId = (pin) => ({
  type: SET_PIN,
  pin,
})

export const SET_OUTPUT_FIELD = 'SET_OUTPUT_FIELD'
export const setOutputField = (paramName, value, outputId) => ({
  type: SET_OUTPUT_FIELD,
  paramName,
  value,
  id: outputId,
})

export const UPDATE_OUTPUT_NODE = 'UPDATE_OUTPUT_NODE'
export const updateOutputNode = createAction(UPDATE_OUTPUT_NODE, [
  'id',
  'nodeSubset',
])

export const ADD_OUTPUT_NODE = 'ADD_OUTPUT_NODE'
export const DELETE_OUTPUT_NODE = 'DELETE_OUTPUT_NODE'
export const UPDATE_OUTPUT_QUERY = 'UPDATE_OUTPUT_QUERY'
export const RESET_OUTPUT_NODE = 'RESET_OUTPUT_NODE'
// const RESET_AFFINITY_HIGHLIGHTS = 'RESET_AFFINITY_HIGHLIGHTS'
export const SET_CAN_ID = 'SET_CAN_ID'

export const addOutputNode = createAction(ADD_OUTPUT_NODE, [
  'outputType',
  'fnId',
  'tmpId',
  'newIndex',
])

export const deleteOutputNode = createAction(DELETE_OUTPUT_NODE, ['id', 'fnId'])
export const updateOutputQuery = createAction(UPDATE_OUTPUT_QUERY, [
  'queryUri',
  'fnId',
])
export const resetOutputNode = createAction(RESET_OUTPUT_NODE, ['id'])
// export const resetAffinityHighlights = createAction(RESET_AFFINITY_HIGHLIGHTS)
// TODO: move to inputs
export const setCanId = createAction(SET_CAN_ID, ['joinQueryUri', 'canId'])

export const SET_SCALING_INPUT_FIELD = 'SET_SCALING_INPUT_FIELD'
export const setScalingInputField = createAction(SET_SCALING_INPUT_FIELD, [
  'paramName',
  'value',
  'id',
])

const CREATE_SCALING_QUERY = 'CREATE_SCALING_QUERY'
export const createScalingQuery = createAction(CREATE_SCALING_QUERY, ['id'])

const REMOVE_SCALING_QUERY = 'REMOVE_SCALING_QUERY'
export const removeScalingQuery = createAction(REMOVE_SCALING_QUERY, ['id'])

const RESET_OUTPUT_FLOATING_CIRCUITS = 'RESET_OUTPUT_FLOATING_CIRCUITS'
export const resetOutputFloatingCircuits = createAction(
  RESET_OUTPUT_FLOATING_CIRCUITS,
  ['ids']
)
